import { capitalize } from 'vue';

import Validatable from '@/validator/Validatable';
import i18n from '@/vueI18n';

export interface IRole {
  id: number;
  code: string;
  createdOnUtc: string;
  modifiedOnUtc: string;
}

export interface IRoleApi {
  role_id: number;
  code: string;
  created_on_utc: string;
  modified_on_utc: string;
}

export default class Role extends Validatable {
  code: string;

  createdOnUtc: string;

  modifiedOnUtc: string;

  constructor(id = -1, code: string, createdOnUtc: string = null, modifiedOnUtc: string = null) {
    super();
    this.id = id;
    this.code = code;
    this.createdOnUtc = createdOnUtc;
    this.modifiedOnUtc = modifiedOnUtc;
  }

  get readableCode(): string {
    return i18n.global.te(`options.roles.${this.code}`)
      ? capitalize(i18n.global.t(`options.roles.${this.code}`))
      : this.code;
  }

  get description() {
    return i18n.global.te(`options.rolesDescriptions.${this.code}`)
      ? capitalize(i18n.global.t(`options.rolesDescriptions.${this.code}`))
      : '';
  }

  static fromApi(apiObject: IRoleApi): Role {
    return new Role(apiObject.role_id, apiObject.code, apiObject.created_on_utc, apiObject.modified_on_utc);
  }

  static fromObject(obj: IRole): Role {
    return super.fromObject(obj, new Role());
  }
}
